import React, {useState} from 'react';
import Upload from "~/Components/Upload/Upload";
import {humanFileSize} from '~/helpers/utils';
import {ProgressBar} from 'react-bootstrap';
import {http} from "~/services/http";
import {adminHttp} from "~/Admin/services/http";
import produce from "immer";
import {removeGuestDocument, updateGuestAction} from "~/redux/actions/guests";
import deleteIcon from "~/assets/icons/delete.png";
import downloadIcon from "~/assets/icons/download.png";
import ConfirmedLink from '~/Components/ConfirmedButton/ConfirmedLink';
import {connect} from 'react-redux';
import TextTranslate from '../../../Components/TextTranslate/TextTranslate';
import './documentuploader.scss';

const DocumentUploader = ({guest, type, isAdmin = false, ...props}) => {
    const [deleteError, setDeleteError] = useState([]);
    const [filesToUpload, setFilesToUpload] = useState([]);

    const uploadedFiles = guest.documents.filter((doc) => doc.type === type);

    //Remove file which is not uploaded yet..
    const removeFile = (file) => {
        const newList = produce(filesToUpload, (draft) => {
            let paths = draft.map((i) => i.path);
            let index = paths.indexOf(file.path);

            draft.splice(index, 1);
        });

        setFilesToUpload(newList);
    }

    //Delete uploaded file...
    const deleteFile = (file) => {
        if(!isAdmin) {
            props.dispatch(removeGuestDocument(file.id)).catch((error) => {
                setDeleteError(error.data);
            });
        } else {
            adminHttp.delete(`/guests/documents/${file.id}`)
                .then(() => {props.onChange()});
        }
    }

    const fileUploaded = (file, guest) => {
        if(!isAdmin){
            props.dispatch(updateGuestAction(guest));
        } else {
            props.onChange();
        }
    };

    return (
        <div className="documents-uploader row no-gutters">
            <div className="upload-block col-lg-6 col-md-12 pr-lg-4 pr-md-2">
                <Upload sendFiles={(files) => setFilesToUpload(files)}/>
            </div>
            <div className="uploaded-files col-lg-6 col-md-12 pl-lg-4 pl-md-2">
                <p className="text-type-caption"><TextTranslate name="docs-uploaded-files" fallback="Uploaded Files" textOnly/></p>
                {filesToUpload.map(file => {
                    return (
                        <UploadingFile
                            key={`${type}_${file.name}`}
                            onDone={(guest) => fileUploaded(file, guest)}
                            onRemove={() => removeFile(file)}
                            guest={guest}
                            file={file}
                            type={type}
                            isAdmin={isAdmin}
                        />
                    )
                })}

                {deleteError?.message && (
                    <div className="alert alert-danger" role="alert">
                        {deleteError.message}
                    </div>
                )}

                {uploadedFiles.map((file) => {
                    return (
                        <UploadedFile
                            key={file.id}
                            onDelete={() => deleteFile(file)}
                            guest={guest}
                            file={file}/>
                    )
                })}

                {filesToUpload.length ===0 && uploadedFiles.length === 0 && (
                    <p className="text-subhead text-color-gray"><TextTranslate name="docs-no-documents" fallback="No documents yet" textOnly/></p>
                )}
            </div>
        </div>
    );
}

const UploadedFile = ({file, guest, onDelete, ...props}) => {

    return (
        <div className="row">
            <div className="col-9">{file.name} <span className="file-size">{humanFileSize(file.size)}</span></div>
            <div className="col-3">
                <a className="mr-1" href={file.download_url}><img src={downloadIcon}/></a>
                <ConfirmedLink onClick={() => onDelete(file)}><img src={deleteIcon}/></ConfirmedLink>
            </div>
        </div>
    );
}

const UploadingFile = ({file, guest, type, onDone, onRemove, isAdmin, ...props}) => {

    const [progress, setProgress] = useState(0);
    const [error, setError] = useState('');
    const [finished, setFinished] = useState(false);
    const [uploading, setUploading] = useState(false);

    const startUpload = () => {
        setUploading(true);

        let formData = new FormData();
        formData.append("guest_id", guest.id);
        formData.append("type", type);
        formData.append("file", file);

        const onUploadProgress = (event) => {
            let newProgress = Math.round((100 * event.loaded) / event.total);
            setProgress(Math.max(newProgress, progress));
        }

        const service = !isAdmin ? http : adminHttp;
        service.post("guests/documents", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                "Content-Language": props.currentLanguage?.code
            },
            onUploadProgress,
        }).then((response) => {
            setFinished(true);
            onDone(response.data);
        }).catch((error) => {
            setProgress(0);
            setError(error.response);
        });
    }

    if (!uploading) {
        startUpload();
    }

    if (finished) {
        return <></>;
    }

    return (
        <>
            <div className="row">
                <div className="col-10">
                    {file.name} <span className="file-size">{humanFileSize(file.size)}</span>
                </div>
                <div className="col-2">
                    <a className="btn" onClick={() => onRemove()}><img src={deleteIcon}/></a>
                </div>
            </div>
            {uploading && (
                <div className="row">
                    <div className="col-12">
                        {!error && <ProgressBar now={progress}/>}
                        {error && <small className="text-danger">{error.data?.message}</small>}
                    </div>
                </div>
            )}
        </>
    );
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations.currentLanguage,
    activeGuest: state.guests?.activeGuest,
    activeStep: state.guests?.activeStep,
});

export default connect(mapStateToProps)(DocumentUploader);
